import * as React from 'react';
import { PublicationsContext, PublicationsDispatchContext } from './publications.context';

export const usePublicationsState = () => {
    const state = React.useContext(PublicationsContext);

    if (state === undefined) {
        throw new Error('usePublicationsState must be used within a PublicationsProvider');
    }

    return state;
};

export const usePublicationsDispatch = () => {
    const state = React.useContext(PublicationsDispatchContext);
    if (state === undefined) {
        throw new Error('usePublicationsState must be used within a PublicationsProvider');
    }

    return state;
};
